(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fluff-friday-coupon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fluff-friday-coupon')) {
    customElements.define('fluff-friday-coupon', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.label = this.querySelector('[data-copy-label]');
        if (!this.button || !this.status || !this.label) return;
        this.controller = new AbortController();
        this.button.addEventListener('click', () => this.copyCode(), { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      fallbackCopy(code) {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;inset-inline-start:-9999px;top:0;opacity:0;font-size:16px;';
        document.body.appendChild(field);
        let copied = false;
        try {
          field.select();
          field.setSelectionRange(0, code.length);
          copied = document.execCommand('copy');
        } finally {
          field.remove();
          this.button.focus({ preventScroll: true });
        }
        if (!copied) throw new Error('Copy unavailable');
      }

      async copyCode() {
        if (this.copying) return;
        this.copying = true;
        const code = this.dataset.code;
        try {
          try {
            if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
            await navigator.clipboard.writeText(code);
          } catch {
            this.fallbackCopy(code);
          }
          this.button.dataset.copied = 'true';
          this.label.textContent = this.dataset.copied;
          this.status.textContent = this.dataset.success;
        } catch {
          this.status.textContent = this.dataset.error;
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(this.querySelector('.fluff-friday-coupon__code'));
          selection.removeAllRanges();
          selection.addRange(range);
        } finally {
          this.copying = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
